<template>
  <div class="webinar-info">

    <div class="watermark">
      <p>{{ $t('poweredBy', { product: '' }) }}</p>
      <img class="logo-product" :src="require('../assets/goto-brand.svg')" />
    </div>

    <p v-if="!isOnDemand" class="time">{{ startTime }}</p>

    <p slot="header" class="subject">{{ webinarInfo.subject }}</p>

    <p class="organizer">
      <b>{{ $t('webinarInfo.organizer') }}:</b>
      <span >{{ webinarInfo.organizerName }}</span>
      <b-link class="email"
        :href="`mailto:${webinarInfo.organizerEmail}`"
        target="hidden-iframe-target"
        @click.native.stop>{{ webinarInfo.organizerEmail }}</b-link>
    </p>

    <div v-if="webinarInfo.description">
      <p class="description">{{ webinarInfo.description }}</p>
    </div>
  </div>
</template>

<script>
const WebinarInfo = {
  name: 'WebinarInfo',

  computed: {
    webinarInfo() {
      return this.$store.state.g2wWebinar.webinarInfo;
    },

    startTime() {
      const startTime = (
        this.webinarInfo.times
        && this.webinarInfo.times[0].startTime
      );

      if (startTime) {
        return this.displayTime(startTime);
      }
      return '';
    },

    embed() {
      return this.$store.state.embed;
    },

    isOnDemand() {
      return (
        this.$store.getters['g2wWebinar/isSimulive']
        && !this.$store.getters['g2wSession/isScheduled']
      );
    }
  },

  methods: {
    displayTime(time) {
      try {
        const locale = this.$store.state.g2wEnv.locale;
        const options = {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
          hour: '2-digit',
          minute: '2-digit'
        };

        return new Date(time).toLocaleString(locale, options);
      } catch (error) {
        this.logger.log('displayTime failure', {error});
        return new Date(time).toLocaleString();
      }
    }
  }
};

export default WebinarInfo;
</script>

<style lang="sass">
  @import 'src/scss/variables';

  .webinar-info
    .subject
      font-weight: bold
      font-size: 20px
      overflow: hidden
      text-overflow: ellipsis

    .time
      font-size: 12px
      color: $grey-street

    a
      text-decoration: none

    .email
      display: block

    .watermark
      font-size: 10px

      p
        margin: 0

      .logo-product
        height: 40px
        margin-left: -10px

</style>
